// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import {
//   Button,
//   Col,
//   Container,
//   Form,
//   ListGroup,
//   Row
// } from 'react-bootstrap';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { toast, ToastContainer } from 'react-toastify';
// import Swal from 'sweetalert2';
// import './CandidateDashboard.css';
import { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import GlobalCandidateSettings from "./GlobalCandidateSettings";
import ApplyToDreamCompany from "./dreamCompanyComponents/ApplyToDreamCompany";
import DreamCompanySelection from "./dreamCompanyComponents/DreamCompanySelection";
import ValueFitQuestions from "./dreamCompanyComponents/ValueFitQuestions";

// const BASE_API_URL = process.env.REACT_APP_API_URL;

// const DreamCompany = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const userId = location.state?.userId;

//   const [companyName, setCompanyName] = useState('');
//   const [companySuggestions, setCompanySuggestions] = useState([]);
//   const [selectedCompany, setSelectedCompany] = useState(null);
//   const [companyNotFoundMessage, setCompanyNotFoundMessage] = useState('');

//   const [resumes, setResumes] = useState([]);
//   const [resumeId, setResumeId] = useState('');

//   // const [showQuestions, setShowQuestions] = useState(false);
//   const [questions, setQuestions] = useState({
//     whyApply: '',
//     whyDream: '',
//     whyFit: ''
//   });

//   useEffect(() => {
//     axios
//       .get(`${BASE_API_URL}/getResume?userId=${userId}`)
//       .then((res) => setResumes(res.data))
//       .catch(() => { });
//   }, [userId]);

//   const handleCompanySearch = async (e) => {
//     const query = e.target.value;
//     setCompanyName(query);
//     // setShowQuestions(query.trim().length > 0);
//     setCompanyNotFoundMessage('');

//     if (!query.trim()) {
//       setCompanySuggestions([]);
//       // setShowQuestions(false);
//       return;
//     }

//     try {
//       const res = await axios.get(
//         `${BASE_API_URL}/searchCompanyNames?companyName=${query}`
//       );
//       setCompanySuggestions(res.data);

//       if (res.data.length === 0) {
//         setCompanyNotFoundMessage(
//           `The company "${query}" does not exist, but you can still apply.`
//         );
//       }
//     } catch {
//       setCompanySuggestions([]);
//     }
//   };

//   const handleSelectCompany = (company) => {
//     setCompanyName(company.companyName);
//     setSelectedCompany(company);
//     setCompanySuggestions([]);
//     // setShowQuestions(true);
//   };

//   const handleQuestionChange = (e) => {
//     const { name, value } = e.target;
//     setQuestions((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleApply = async () => {
//     if (!resumeId) return toast.error('Please select a resume.');
//     if (!questions.whyApply || !questions.whyDream || !questions.whyFit)
//       return toast.error('Please answer all questions.');

//     const companyToApply = selectedCompany
//       ? selectedCompany.companyName
//       : companyName;

//     try {
//       Swal.fire({
//         title: 'Applying...',
//         allowOutsideClick: false,
//         didOpen: () => Swal.showLoading()
//       });

//       const today = new Date().toISOString().split('T')[0];

//       // const res = await axios.put(
//       //   `${BASE_API_URL}/applyDreamCompany?userId=${userId}&companyName=${companyToApply}&formattedDate=${today}&resumeId=${resumeId}`
//       // );

//       const res = await axios.put(
//         `${BASE_API_URL}/applyDreamCompanyWithQuestion`,
//         null,
//         {
//           params: {
//             userId,
//             companyName: companyToApply,
//             appliedDate: today,
//             resumeId,
//             whyApply: questions.whyApply,
//             whyDream: questions.whyDream,
//             whyFit: questions.whyFit
//           }
//         }
//       );

//       Swal.close();

//       if (res.data) {
//         Swal.fire('Success', 'Application submitted!', 'success');

//         // Reset form fields
//         setCompanyName('');
//         setSelectedCompany(null);
//         setCompanySuggestions([]);
//         setCompanyNotFoundMessage('');
//         setQuestions({ whyApply: '', whyDream: '', whyFit: '' });
//         setResumeId('');

//         // navigate('/candidate-dashboard/my-application', {
//         //   state: { userId }
//         // });
//       } else {
//         Swal.fire(
//           'Already Applied',
//           `You already applied for ${companyToApply}`,
//           'warning'
//         );
//       }
//     } catch {
//       Swal.fire('Error', 'Something went wrong.', 'error');
//     }
//   };

//   return (
//     <DashboardLayout>
//       <div className="main-content">
//         {/* Header */}
//         <Row className="d-flex justify-content-between align-items-center mb-3">
//           <Col>
//             <h2 className='text-start' style={{ paddingLeft: '12px', marginBottom: 0 }}>Dream Company</h2>
//           </Col>
//           <Col xs="auto">
//             <GlobalCandidateSettings userId={userId} />
//           </Col>
//         </Row>

//         <Button
//           variant="primary"
//           onClick={() => navigate(-1)}
//           style={{ width: '100px', marginBottom: '20px' }}
//         >
//           Back
//         </Button>

//         <Container className="d-flex justify-content-center py-4">
//           <div className="w-100" style={{ maxWidth: '600px' }}>
//             {/* Card */}
//             <div className="text-center mb-4">
//               <h2 className="text-primary">Dream Company Application</h2>
//               <p className="text-muted">
//                 Apply to your dream company by selecting a resume and answering
//                 a few questions.
//               </p>
//             </div>

//             <Form className="p-4 bg-white rounded shadow-sm">
//               {/* Company */}
//               <Form.Group className="mb-3 position-relative">
//                 <Form.Label className="fw-bold">
//                   Company Name
//                 </Form.Label>
//                 <Form.Control
//                   value={companyName}
//                   onChange={handleCompanySearch}
//                   placeholder="Enter company name"
//                 />

//                 {companyNotFoundMessage && (
//                   <small className="text-danger">
//                     {companyNotFoundMessage}
//                   </small>
//                 )}

//                 {companySuggestions.length > 0 && (
//                   <ListGroup
//                     className="position-absolute w-100 mt-1 shadow"
//                     style={{ maxHeight: '180px', overflowY: 'auto', zIndex: 10 }}
//                   >
//                     {companySuggestions.map((c) => (
//                       <ListGroup.Item
//                         key={c.id}
//                         action
//                         onClick={() => handleSelectCompany(c)}
//                       >
//                         {c.companyName}
//                       </ListGroup.Item>
//                     ))}
//                   </ListGroup>
//                 )}
//               </Form.Group>

//               {/* Questions */}
//               {/* {showQuestions && ( */}
//               <>
//                 <Form.Group className="mb-3">
//                   <Form.Label className="fw-semibold">
//                     Why do you want to apply to this company?
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     name="whyApply"
//                     value={questions.whyApply}
//                     onChange={handleQuestionChange}
//                     placeholder="Your motivation..."
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label className="fw-semibold">
//                     Why do you think this is your dream company?
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     name="whyDream"
//                     value={questions.whyDream}
//                     onChange={handleQuestionChange}
//                     placeholder="What makes it special?"
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-4">
//                   <Form.Label className="fw-semibold">
//                     Why are you a good fit for this company?
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     name="whyFit"
//                     value={questions.whyFit}
//                     onChange={handleQuestionChange}
//                     placeholder="Your skills & strengths..."
//                   />
//                 </Form.Group>
//               </>
//               {/* // )} */}

//               {/* Resume */}
//               <Form.Group className="mb-4">
//                 <Form.Label className="fw-bold">
//                   Select Resume
//                 </Form.Label>
//                 <Form.Select
//                   value={resumeId}
//                   onChange={(e) => setResumeId(e.target.value)}
//                 >
//                   <option value="">Select Resume</option>
//                   {resumes.map((r) => (
//                     <option key={r.id} value={r.id}>
//                       {r.message}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>

//               <Button
//                 className="w-100 fw-bold"
//                 disabled={
//                   !companyName ||
//                   !resumeId ||
//                   !questions.whyApply ||
//                   !questions.whyDream ||
//                   !questions.whyFit
//                 }
//                 onClick={handleApply}
//               >
//                 Apply
//               </Button>
//             </Form>
//           </div>
//         </Container>

//         <ToastContainer />
//       </div>
//     </DashboardLayout>
//   );
// };

// export default DreamCompany;

const DreamCompany = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = location.state?.userId;
  const { step } = useParams();
  const currentStep = parseInt(step || 1);

  const [companyName, setCompanyName] = useState(
    location.state?.companyName || ""
  );
  const [resumeId, setResumeId] = useState(location.state?.resumeId || "");
  const [questions, setQuestions] = useState(
    location.state?.questions || {
      whyApply: "",
      whyDream: "",
      whyFit: "",
    }
  );
  const [score, setScore] = useState(location.state?.score || 0);
  const [resumeName, setResumeName] = useState(
    location.state?.resumeName || ""
  );

  const goToStep = (nextStep) => {
    navigate(`/candidate-dashboard/jobs/dream-company/step/${nextStep}`, {
      state: { userId, companyName, resumeId, resumeName, questions, score },
    });
  };

  const handleNext = () => goToStep(currentStep + 1);
  const handlePrevious = () => {
    navigate(
      `/candidate-dashboard/jobs/dream-company/step/${currentStep - 1}`,
      {
        state: { userId, companyName, resumeId, resumeName, questions, score },
      }
    );
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <DashboardLayout>
      <div className="main-content">
        <Row className="d-flex justify-content-between align-items-center mb-3">
          <Col>
            <h2
              className="text-start"
              style={{ paddingLeft: "12px", marginBottom: 0 }}
            >
              Dream Company
            </h2>
          </Col>
          <Col xs="auto">
            <GlobalCandidateSettings userId={userId} />
          </Col>
        </Row>

        <Button
          variant="primary"
          onClick={handleBack}
          style={{ width: "100px", marginBottom: "20px" }}
        >
          Back
        </Button>

        <Container className="d-flex justify-content-center py-4">
          <div className="text-center mb-4">
            <h2 className="text-primary">Dream Company Application</h2>
            <p className="text-muted">
              Apply to your dream company by selecting a resume and check
              yourself why you are a good fit.
            </p>
            <p className="text-muted">Step {currentStep} of 3</p>
          </div>
        </Container>

        {currentStep === 1 && (
          <DreamCompanySelection
            userId={userId}
            setCompanyName={setCompanyName}
            setResumeId={setResumeId}
            setQuestions={setQuestions}
            onNext={handleNext}
            companyName={companyName}
            resumeId={resumeId}
            setResumeName={setResumeName}
            questions={questions}
          />
        )}
        {currentStep === 2 && (
          <ValueFitQuestions
            userId={userId}
            companyName={companyName}
            resumeId={resumeId}
            resumeName={resumeName}
            questions={questions}
            onPrevious={handlePrevious}
            onNext={handleNext}
            score={score}
            setScore={setScore}
          />
        )}
        {currentStep === 3 && (
          <ApplyToDreamCompany
            userId={userId}
            companyName={companyName}
            resumeId={resumeId}
            resumeName={resumeName}
            questions={questions}
            score={score}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
        )}
      </div>
    </DashboardLayout>
  );
};

export default DreamCompany;
